import { render, staticRenderFns } from "./collaborators.vue?vue&type=template&id=e7c1ecc0&scoped=true&"
import script from "./collaborators.vue?vue&type=script&lang=js&"
export * from "./collaborators.vue?vue&type=script&lang=js&"
import style0 from "./collaborators.vue?vue&type=style&index=0&id=e7c1ecc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c1ecc0",
  null
  
)

export default component.exports